import { makeStyles, shorthands } from '@fluentui/react-components';

/**
 * Common styles shared across all settings pages (General, Email, Teams Sync)
 * to eliminate duplication and ensure consistency
 */
export const useCommonSettingsStyles = makeStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...shorthands.borderBottom('3px', 'solid', '#0047AB'),
    ...shorthands.padding('0', '0', '20px', '0'),
    ...shorthands.margin('0', '0', '24px', '0'),
  },
  title: {
    fontSize: '36px',
    fontWeight: '700',
    color: '#1a1a1a',
    letterSpacing: '-0.5px',
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('12px'),
  },
});
